// store/wishlist/wishlist.reducer.js
import { createSlice } from '@reduxjs/toolkit';

export const wishlistSlice = createSlice({
  name: 'wishlist',
  initialState: {
    wishlistItems: [],
  },
  reducers: {
    addToWishlist: (state, action) => {
      if (!state.wishlistItems.find((item) => item.id === action.payload.id)) {
        state.wishlistItems.push(action.payload);
      }
    },
    removeFromWishlist: (state, action) => {
      state.wishlistItems = state.wishlistItems.filter(
        (item) => item.id !== action.payload.id
      );
    },
  },
});

export const { addToWishlist, removeFromWishlist } = wishlistSlice.actions;
export const wishlistReducer = wishlistSlice.reducer;

// // store/wishlist/wishlist.reducer.js
// import { createSlice } from '@reduxjs/toolkit';

// export const wishlistSlice = createSlice({
//   name: 'wishlist',
//   initialState: {
//     items: [],
//   },
//   reducers: {
//     addToWishlist: (state, action) => {
//       if (!state.items.find((item) => item.id === action.payload.id)) {
//         state.items.push(action.payload);
//       }
//     },
//     removeFromWishlist: (state, action) => {
//       state.items = state.items.filter((item) => item.id !== action.payload.id);
//     },
//   },
// });

// export const { addToWishlist, removeFromWishlist } = wishlistSlice.actions;
// export default wishlistSlice.reducer;
